import {
  formatAppointmentDateWithWeekday,
  formatAppointmentTime,
} from "@zapis24/utils";
import {
  clearAuthSession,
  readStoredAuthSession,
  refreshStoredAuthSession,
} from "./authSession.js";

export const API_BASE = (import.meta.env["VITE_API_URL"] as string | undefined) ?? "";

export async function apiFetch<T>(
  token: string,
  path: string,
  opts?: RequestInit
): Promise<T> {
  const makeRequest = (accessToken: string) =>
    fetch(`${API_BASE}${path}`, {
      ...opts,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        ...(opts?.headers ?? {}),
      },
    });

  let res = await makeRequest(readStoredAuthSession()?.accessToken ?? token);

  if (res.status === 401) {
    const refreshedToken = await refreshStoredAuthSession(API_BASE);
    if (refreshedToken) {
      window.dispatchEvent(
        new CustomEvent("admin-auth-token-refreshed", {
          detail: { accessToken: refreshedToken },
        }),
      );
      res = await makeRequest(refreshedToken);
    }
  }

  if (res.status === 401) {
    clearAuthSession();
    window.location.reload();
    throw new Error("Сессия истекла. Пожалуйста, войдите снова.");
  }

  const json = (await res.json()) as { ok: boolean; data?: T; error?: string };
  if (!json.ok) {
    const error = json.error ?? `Request failed: ${path}`;
    if (error.startsWith("BILLING_ACCESS_BLOCKED:")) {
      throw new Error("Онлайн-запись временно недоступна. Обратитесь в поддержку Запись24.");
    }
    if (error.startsWith("BILLING_ACCESS_READ_ONLY:")) {
      throw new Error("Кабинет временно доступен только для просмотра. Обратитесь в поддержку Запись24.");
    }
    throw new Error(error);
  }
  return json.data as T;
}

export function fmtPrice(kopecks: number): string {
  return `${Math.floor(kopecks / 100).toLocaleString("ru")} ₽`;
}

export function fmtDate(iso: string | Date, timeZone?: string): string {
  return formatAppointmentDateWithWeekday(iso, timeZone);
}

export function fmtTime(iso: string | Date, timeZone?: string): string {
  return formatAppointmentTime(iso, timeZone);
}

/** YYYY-MM-DD из Date (локальное время, без UTC-сдвига) */
export function toLocalDateStr(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
